import { DeliveryTypeProduct } from '@app/entities/Delivery';
import { Part, PartProduct } from '@app/entities/Product';

export enum TypeTemplateFastOrder {
  pickUpStore = 'pickUpStore',
  orderOneClick = 'orderOneClick',
  pickUpStoreMap = 'pickUpStoreMap',
  successTemplate = 'successTemplate',
}

export interface PickUpShopsType {
  address: string;
  name: string;
  url: string;
  phone: string;
  sort?: number;
  distance?: number;
  quantityToday?: number;
  quantityNoToday?: number;
  statusDeliveryToday?: number;
  statusDeliveryNoToday?: number;
  shopId: number;
  type: DeliveryTypeProduct[];
  partner: number;
  timeWork: string;
  map: {
    x: number;
    y: number;
    zoom: number;
  };
  sticky?: boolean;
  record?: boolean;
  yandexRating?: string;
  yandexAmountView?: string;
  yandexReviews?: string;
}

interface ShopOrder extends PickUpShopsType {
  phone: string;
  timeWork: string;
}

export type ProductsOrder = {
  title: string;
  quantity: number;
  price: number;
  rn?: number;
};

export interface OrderSchema {
  shop: ShopOrder;
  orderNumber: string;
  totalSum: number;
  products: ProductsOrder[];
  id: number;
  hash: string;
}

export type ProductType = {
  productName: string;
  productSpecName?: string;
  productId: number;
  productRn: number;
  part: PartProduct | Part;
  price: number;
  quantity: number;
  allQuantity: number;
};

export type TypeError = {
  errorCode: number;
  errorMessage: string;
  redirect: string;
  success: boolean;
};

export type ErrorDataType = { data: TypeError; status: number };

export interface fastOrderSchema {
  shops: PickUpShopsType[];
  historyShops: PickUpShopsType[];
  historyRnProduct: number;
  product: ProductType;
  order: OrderSchema;
  currentShop: PickUpShopsType;
  transferredShopId?: number;
  template: TypeTemplateFastOrder;
  isAddDistance?: boolean;
  isOpen: boolean;
  isSuccess: boolean;
  isLoadedShops: boolean;
  isHideShopTwoHours: boolean;
  isProductsIsBasket: boolean;
  errorData: ErrorDataType;
  count: number;
  filterShops: PickUpShopsType[];
  openShopId: number;
}
